export default __webpack_public_path__ + "b232d28ab39629bc89ab6bab8976f058.png";